import DepartmentActions, { departmentActionTypes } from '@Actions/departmentActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import DepartmentService from '@Services/departmentServices';
import { notification } from 'antd';

/**
 * @param action
 */
function* _createDepartment(action) {
  try {
    yield put(DepartmentActions.createDepartmentLoading(true));
    const { payload } = action;
    const department = yield DepartmentService.createDepartment(payload);
    if (!department.success) {
      notification.open({
        type: 'error',
        message: department?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(departmentActionTypes.CREATE_DEPARTMENT.SUCCESS, department.data));
      notification.open({
        type: 'success',
        message: 'Department created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(department.department);
      }
    }
    yield put(DepartmentActions.createDepartmentLoading(false));
  } catch (error) {
    yield put(DepartmentActions.createDepartmentLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.CREATE_DEPARTMENT.ERROR, error));
  }
}

/**
 *
 */
function* createDepartment() {
  yield takeLatest(departmentActionTypes.CREATE_DEPARTMENT.REQUEST, _createDepartment);
}

/**
 * @param action
 */
function* _getDepartmentById(action) {
  try {
    yield put(DepartmentActions.getDepartmentByIdLoading(true));
    const selectedDepartment = yield DepartmentService.getDepartmentById(action.departmentId, action.tenantId);
    yield put(DepartmentActions.getDepartmentByIdSuccess(selectedDepartment?.departments?.[0]));
    yield put(DepartmentActions.getDepartmentByIdLoading(false));
  } catch (error) {
    yield put(DepartmentActions.getDepartmentByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.GET_DEPARTMENT_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getDepartmentById() {
  yield takeLatest(departmentActionTypes.GET_DEPARTMENT_BY_ID.REQUEST, _getDepartmentById);
}

/**
 * @param action
 */
function* _getDepartments(action) {
  try {
    yield put(DepartmentActions.getDepartmentsLoading(true));
    const departments = yield DepartmentService.getDepartments(action.keyword, action.tenantId, action.page, action?.limit, action?.departmentId, action?.orgId, action?.isAdmin, action?.multipleSelectedTenantIds);
    yield put(DepartmentActions.getDepartmentsSuccess(departments));
    yield put(DepartmentActions.getDepartmentsLoading(false));
    if (action.callback) {
      action.callback(departments);
    }
  } catch (error) {
    yield put(DepartmentActions.getDepartmentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.GET_DEPARTMENTS.ERROR, error));
  }
}

/**
 *
 */
function* getDepartments() {
  yield takeLatest(departmentActionTypes.GET_DEPARTMENTS.REQUEST, _getDepartments);
}

/**
 * @param action
 */
function* _updateDepartment(action) {
  try {
    yield put(DepartmentActions.updateDepartmentLoading(true));
    const { payload } = action;
    const updatedDepartment = yield DepartmentService.updateDepartment(payload);
    if (!updatedDepartment.success) {
      yield put(TrackerActions.trackAction(departmentActionTypes.UPDATE_DEPARTMENT.SUCCESS, updatedDepartment.data));
      notification.open({
        type: 'error',
        message: updatedDepartment.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Department update successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(DepartmentActions.updateDepartmentLoading(false));
  } catch (error) {
    yield put(DepartmentActions.updateDepartmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.UPDATE_DEPARTMENT.ERROR, error));
  }
}

/**
 *
 */
function* updateDepartment() {
  yield takeLatest(departmentActionTypes.UPDATE_DEPARTMENT.REQUEST, _updateDepartment);
}

/**
 * @param action
 */
function* _updateDepartmentStatus(action) {
  try {
    yield put(DepartmentActions.updateDepartmentStatusLoading(true));
    const so = yield DepartmentService.updateDepartmentStatus(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Department status successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DepartmentActions.updateDepartmentStatusLoading(false));
  } catch (error) {
    yield put(DepartmentActions.updateDepartmentStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.UPDATE_STATUS_DEPARTMENT.ERROR, error));
  }
}

/**
 *
 */
function* updateDepartmentStatus() {
  yield takeLatest(departmentActionTypes.UPDATE_STATUS_DEPARTMENT.REQUEST, _updateDepartmentStatus);
}

/**
 * @param action
 */
function* _deleteDepartment(action) {
  try {
    yield put(DepartmentActions.deleteDepartmentLoading(true));
    const so = yield DepartmentService.deleteDepartment(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Department successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DepartmentActions.deleteDepartmentLoading(false));
  } catch (error) {
    yield put(DepartmentActions.deleteDepartmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(departmentActionTypes.DELETE_DEPARTMENT.ERROR, error));
  }
}

/**
 *
 */
function* deleteDepartment() {
  yield takeLatest(departmentActionTypes.DELETE_DEPARTMENT.REQUEST, _deleteDepartment);
}

/**
 *
 */
export default function* customerSaga() {
  yield all([createDepartment(), getDepartmentById(), getDepartments(), updateDepartment(), updateDepartmentStatus(), deleteDepartment()]);
}
